// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__21Pbo","info":"UpdateTermsInfo_info__2dTJa"};